import { z } from 'zod';
import { ExperienceTypeSchema } from '@features/DynamicPackagesConfigurationWizard/types';

const SingleSelectedExperienceSchema = z.object({
  type: ExperienceTypeSchema,
  id: z.number(),
  delayAfter: z.number().optional(),
  optionGroupId: z.number().or(z.string()).optional(),
  optionId: z.number().or(z.string()),
  dayNumber: z.number(),
  dayNumberRange: z.array(z.number()).optional(),
  count: z.number().default(0),
  isIncluded: z.boolean(),
  numberOfGroupSelectionsRequired: z.number().default(1),
  startTime: z.string().optional(),
  guestsUseSameTime: z.boolean().optional(),
});
export const SelectExperienceSchema = z.array(SingleSelectedExperienceSchema);

export type SelectedExperienceType = z.infer<typeof SingleSelectedExperienceSchema>;
